module.exports = __webpack_public_path__ + "static/media/AeroGCSEnterprise.af159722.svg";